import React from 'react'
import styled from 'styled-components'
import {colors, typography, utils} from '../styles'

const Outer = styled.div`
  color: ${colors.blueText};
  margin-bottom: 1rem;
  text-align: center;
`

const Inner = styled.div`
  ${utils.container}
  border-bottom: 3px solid;
`

const Above = styled.div`
  ${typography.bold.uppercase}
  ${props => props.prerelease && 'opacity: 0.5;' }
`
const Below = styled.div`
  ${typography.h1.bold.lh14}
`

const Headline = ({ above, children, prerelease }) => (
  <Outer>
    <Inner>
      <Above prerelease={prerelease}>{above}</Above>
      <Below>{children}</Below>
    </Inner>
  </Outer>
)

export default Headline



/** WEBPACK FOOTER **
 ** ./src/components/Headline.js
 **/